module.exports = __webpack_public_path__ + "img/yuanxiaoduibi.79dc9f6c.png";